module.exports = __webpack_public_path__ + "img/solution2.83285efd.png";